var $ = jQuery.noConflict();

// active on clicked, unactive others
$('[data-active-trigger]').on('click', function (e) {
    const activeTrigger = $(this).data('active-trigger');
    const activeTarget = $(this).closest('section, header, footer').find('[data-active-target=' + activeTrigger + ']');

    $(this).closest('section').find('[data-active-trigger]').removeClass('active');
    $(this).addClass('active');

    $(this).closest('section').find('[data-active-target]').removeClass('active');
    if ($(this).hasClass('active')) {
        $(activeTarget).addClass('active');
    }
});

// remove active on click
$('[data-remove-active-trigger]').on('click', function (e) {
    const removeTrigger = $(this).data('remove-active-trigger');
    const removeTarget = $('[data-remove-active-target=' + removeTrigger + ']');
    const removeTriggersAll = $('[data-remove-active-trigger=' + removeTrigger + ']');

    removeTarget
        .removeClass('active')
        .removeClass(function (index, className) {
            return (className.match(/\S+--open/g) || []).join(' ');
        });
    removeTriggersAll
        .removeClass('active')
        .removeClass(function (index, className) {
            return (className.match(/\S+--open/g) || []).join(' ');
        });
});

// active on clicked and unclick, unactive others
// used in top menu icons
$('[data-toggle-trigger]').on('click', function (e) {
    const toggleTrigger = $(this).data('toggle-trigger');
    const toggleTarget = $(this).closest('section, header, footer').find('[data-toggle-target=' + toggleTrigger + ']');

    $('[data-toggle-trigger]').not(this).each(function () {
        $(this).removeClass('active');
    });
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $(this).addClass('active');
    }
    $('[data-toggle-target]').removeClass('active');
    if ($(this).hasClass('active')) {
        $(toggleTarget).addClass('active');
    }
});

$('[data-active-remove]').on('click', function (e) {
    $(this).removeClass('active');
});

if (document.getElementById('c-infobar-hover')) {
    document.getElementById('c-infobar-hover').addEventListener('mouseenter', (event) => {
        let target = document.querySelector('[data-toggle-target="' + event.target.getAttribute('data-hover') + '"]');
        target.classList.add('c-infobar__info-text--show');
    });
    document.getElementById('c-infobar-hover').addEventListener('mouseleave', (event) => {
        let target = document.querySelector('[data-toggle-target="' + event.target.getAttribute('data-hover') + '"]');
        target.classList.remove('c-infobar__info-text--show');
    });
}
